// Chakra Imports
import {
    Box,
    Flex,
    useColorModeValue,
    Text,
    HStack,
    Image,
    Tooltip,
} from "@chakra-ui/react";
import { useAuth } from "Providers/AuthProvider";
import React from "react";
import PublicNavbarLinks from "./PublicNavbarLinks";
import InmetLogo from "../../assets/img/inmet.webp";

export default function PublicNavbar(props) {
    const auth = useAuth();
    const {
        variant,
        children,
        fixed,
        secondary,
        brandText,
        onOpen,
        ...rest
    } = props;

    // Modern dark green navbar styling
    let navbarPosition = "fixed";

    // Light mode: solid dark green, Dark mode: darker green with transparency
    let navbarBg = useColorModeValue(
        "linear-gradient(135deg, #2D6B3F 0%, #1F5A2F 100%)",
        "linear-gradient(135deg, rgba(31, 90, 47, 0.95) 0%, rgba(22, 74, 36, 0.95) 100%)"
    );
    let navbarShadow = useColorModeValue(
        "0px 4px 24px rgba(45, 107, 63, 0.25)",
        "0px 4px 24px rgba(0, 0, 0, 0.4)"
    );
    let navbarBorder = useColorModeValue(
        "rgba(255, 255, 255, 0.1)",
        "rgba(255, 255, 255, 0.05)"
    );
    let navbarBackdrop = useColorModeValue("none", "blur(20px)");

    // Text is always light on dark green background
    let mainText = "white";
    let subtitleText = useColorModeValue("whiteAlpha.800", "whiteAlpha.700");

    let paddingX = "15px";
    if (props.fixed !== true) {
        navbarPosition = "absolute";
        navbarShadow = "none";
        navbarBg = "transparent";
        navbarBorder = "transparent";
    }
    if (props.secondary) {
        navbarBackdrop = "none";
        navbarPosition = "absolute";
        paddingX = "30px";
    }

    const greeting = () => {
        let greeting = '';
        var data = [
            [0, 4, "Boa noite"],
            [5, 11, "Bom dia"],
            [12, 17, "Boa tarde"],
            [18, 24, "Boa noite"]
        ],
        hr = new Date().getHours();

        for(var i = 0; i < data.length; i++){
            if(hr >= data[i][0] && hr <= data[i][1]){
                greeting = data[i][2];
            }
        }
        return greeting;
    }

    return (
        <Flex
            position={navbarPosition}
            boxShadow={navbarShadow}
            bg={navbarBg}
            borderColor={navbarBorder}
            backdropFilter={navbarBackdrop}
            borderBottomWidth="1px"
            borderStyle="solid"
            transition="all 0.3s ease"
            alignItems="center"
            display="flex"
            minH={{ base: "60px", md: "56px" }}
            justifyContent="center"
            mx="auto"
            px={{ base: paddingX, md: "24px", lg: "32px" }}
            w="100%"
            zIndex={100}
            top={0}
            left={0}
            right={0}
        >
            <Flex
                w="100%"
                maxW="1800px"
                flexDirection={{ base: "column", md: "row" }}
                alignItems="center"
                justifyContent="space-between"
            >
                {/* Brand Section */}
                <HStack
                    spacing={3}
                    mb={{ base: "6px", md: "0px" }}
                    py={{ base: 2, md: 0 }}
                >
                    <HStack spacing={2}>
                        <Image
                            src="/wsclima-logo.png"
                            alt="WS Clima Logo"
                            h={{ base: "32px", md: "36px" }}
                            w="auto"
                            objectFit="contain"
                        />
                        <Tooltip label="Em parceria com INMET" placement="bottom">
                            <Image
                                src={InmetLogo}
                                alt="INMET Logo"
                                h={{ base: "28px", md: "32px" }}
                                w="auto"
                                objectFit="contain"
                                opacity={0.9}
                                _hover={{ opacity: 1 }}
                                transition="opacity 0.2s"
                            />
                        </Tooltip>
                    </HStack>
                    <Box textAlign={{ base: "center", md: "left" }}>
                        <Text
                            fontSize={{ base: "sm", md: "md" }}
                            fontWeight="bold"
                            color={mainText}
                            letterSpacing="tight"
                            lineHeight="1.2"
                        >
                            WS Consultoria Climatológica
                        </Text>
                        <Text
                            fontSize="xs"
                            color={subtitleText}
                            fontWeight="medium"
                        >
                            {greeting()}, {auth.check() ? auth.getUser().name : 'Visitante'}
                        </Text>
                    </Box>
                </HStack>

                {/* Navigation Links */}
                <Box w={{ base: "100%", md: "auto" }}>
                    <PublicNavbarLinks
                        onOpen={props.onOpen}
                        logoText={props.logoText}
                        secondary={props.secondary}
                        fixed={props.fixed}
                    />
                </Box>
            </Flex>
        </Flex>
    );
}
